﻿const enum TYPEHEADER {
  urlencoded,
  json
}

export enum EVENTO {
  crear,
  editar,
  consultar,
  listar,
  ocultar,
  asignar,
  asignar2,
  crearDocumento,
  editarDocumento,
  consultarDocumento,
  asignarAutonomia,
  guardarAutonomia,
  accesoUsuario,
  accesoSubmodulo
}

export enum TYPEPAGE {
  new,
  edit,
  view,
  list
}


export enum ACTIONS {
  new,
  save,
  newUser,
  newDocumento
}

export const TYPEBUTTON = {
  submit: "submit",
  button: "button"
}

export const ICONS = {
  more: "add",
  new: "add",
  save: "done",
  add: "add",

  // phone: "phone",
  // mail: "mail",
  // room: "room",
  // version: "add",
  // condiciongeneral: "subject",
  // etario: "credit_card",
  // grupoFamiliar: "credit_card",
  // paquete: "credit_card",
  // concepto: "bookmark",
  // plan: "description",
  // promotor: "person_outline",
  // adenda: "sort",
  // afiliado: "person_add",
  // generarcronograma: "event",
  // regenerarcronograma: "update"
}

export const TOOLTIPS = {
  new: "Nuevo",
  save: "Guardar"
}

export enum TYPEMESSAGE {
  Correcto,
  Error,
  Informacion,
  Advertencia
}

export enum LOADPAGE {
  firstLoad = 1,
  postback = 2
}

export enum TYPEMODULE {
  Security
}

export enum TYPECONTROL {
  autocomplete,
  typeahead
}

export const CONSTANT = {
  aplicacionIDDefault: 1,
  officeIDDefault: 1,
  ModuleIDDefault: 4,
  estadoRegistro: {
    inactivo: false,
    activo: true
  },
  pageSizeOptions: [5, 10, 25, 50],
  pageSize: 10,
  cantCaracteres: 3,
  msgNotDataFoundDefault: "No se encontraron resultados.",
  extensionArchivo: {
    excel: ".xls",
    pdf: ".pdf",
    word: ".xls",
    jpg: ".jpg",
    png: ".png",
  },
  contentType: {
    excel: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    pdf: "application/pdf",
    word: "",
    jpg: "",
    png: "",
  },
  fechasValidacion: {
    AniosMinimoDefault: 200,
    AniosMaximoDefault: 0,
    AniosMayorEdad: 18
  },
  typeView: {
    view: 0,
    edit: 1
  },
  pathFileUpload: {
    documentos: "documentos",
    imagenes: "imagenes",
    imageDefault: './assets/images/avatar_default.png',
    temp: "temp"
  },
  typeImage: {
    view: 0,
    edit: 1
  },
  imagen: {
    clase: {
      imagen: 'imagen',
      documento: 'documento'
    },
    tipo: {
      usuario: 'usuario',
      cheque: 'cheque',
      voucher: 'voucher'
    }
  },
  kMicrobankId: 1,
  nivelAcceso: {
    oficina: 1,
    region: 2,
    zona: 3,
  }
};
